<template>

  <div class="drop-area"
    @dragenter.prevent="addClass" @dragover.prevent="addClass"
    @dragleave.prevent="removeClass" @drop.prevent="dataTransfer"
    @click="findFile"
    :class="{ highlight: highlight, [sizeClass]: true }">

    <div class="my-form">
      <slot/>
      <input type="file" :multiple="isMultiple" :accept="accept" ref="file" @change="change">
    </div>

  </div>

</template>

<script>
  export default {
    computed: {
      sizeClass() {
        return this.listClass || 'size-drop-area'
      }
    },
    data() {
      return {
        files: [],
        highlight: false,
        notDrop: false,
      }
    },
    methods: {
      addClass() {
        this.highlight = true
      },
      change(e) {
        this.sendFile([...e.target.files])
        e.target.value = ''
      },
      dataTransfer(e) {
        this.removeClass();
        this.sendFile([...e.dataTransfer.files])
      },
      findFile() {
        this.$refs.file.click()
      },
      removeClass() {
        this.highlight = false
      },
      sendFile(files) {
        if (this.method)
          this.method(files)
        else
          this.$emit('changeFiles', files)
      }
    },
    name: 'Upload',
    props: {
      accept: { default: '*' },
      isMultiple: { default: true },
      listClass: { default: null, type: [String, Array] },
      maxFileSize: { default: 1000000000, type: Number },
      method: { default: null, type: Function }
    },
  }
</script>

<style scoped lang="scss">

@import "./src/assets/utilities/_variables.scss";

  .drop-area {
    cursor: pointer;
    border: 1px dashed #465059;
    box-sizing: border-box;
    border-radius: 5px;
    opacity: 0.5;
  }

  .size-drop-area {
    width: 100%;
    height: 90px;
    margin: 16px auto;
    padding: 8px;
  }

  .highlight {
    border-color: $primary-text-color;
    border-width: 2px;
  }

  .my-form {
    margin-bottom: 10px;
  }

  .drop-area input[type=file] {
    display: none;
  }

</style>
